export const environment = {
  URL_API: 'https://cms-integracao.rodobens.com.br/api',
  URL_API_LEADS_DIGITAL: 'https://leadsdigital.rodobens.com.br/api',
  URL_API_CMS_INTEGRACAO: 'https://cms-integracao.rodobens.com.br/api',
  production: true,
  site: 'mbbVeiculosComerciais'
};
